import { call, put, takeEvery } from 'redux-saga/effects';
import { scoringActions } from './scoringSlice';
import {
    getStudentTestScoresApi,
    getAttemptHistoryApi,
    getStudentChapterScoresApi,
    getChapterAttemptHistoryApi,
    getAssessmentSummaryApi,
    getStrengthsWeaknessesApi,
} from './scoringBaseApi';
import { toastAction } from '../toast/toast';

function* onLoadStudentTests({ payload }) {
    try {
        const studentId = payload?.studentId;
        if (!studentId) return;
        yield put(scoringActions.setStudentTestsLoading(true));
        const response = yield call(getStudentTestScoresApi, studentId);
        // `api.get` returns the parsed JSON envelope { data, ... }
        yield put(scoringActions.setStudentTests(response?.data || []));
    } catch (error) {
        yield put(scoringActions.setStudentTestsError(error?.message || 'Failed to load test scores'));
        yield put(toastAction.onErrorToast(error?.message || 'Failed to load test scores'));
    }
}

function* onLoadAttemptHistory({ payload }) {
    try {
        const studentId = payload?.studentId;
        const assessmentId = payload?.assessmentId;
        if (!studentId || !assessmentId) return;
        yield put(scoringActions.setAttemptHistoryLoading(true));
        const response = yield call(getAttemptHistoryApi, studentId, assessmentId);
        const dto = response?.data ? { ...response.data, kind: 'test' } : null;
        yield put(scoringActions.setAttemptHistory(dto));
    } catch (error) {
        yield put(scoringActions.setAttemptHistoryError(error?.message || 'Failed to load attempt history'));
        yield put(toastAction.onErrorToast(error?.message || 'Failed to load attempt history'));
    }
}

function* onLoadStudentChapters({ payload }) {
    try {
        const studentId = payload?.studentId;
        if (!studentId) return;
        yield put(scoringActions.setStudentChaptersLoading(true));
        const response = yield call(getStudentChapterScoresApi, studentId);
        yield put(scoringActions.setStudentChapters(response?.data || []));
    } catch (error) {
        yield put(scoringActions.setStudentChaptersError(error?.message || 'Failed to load reading sessions'));
        yield put(toastAction.onErrorToast(error?.message || 'Failed to load reading sessions'));
    }
}

function* onLoadChapterAttemptHistory({ payload }) {
    try {
        const studentId = payload?.studentId;
        const chapterId = payload?.chapterId;
        if (!studentId || !chapterId) return;
        yield put(scoringActions.setAttemptHistoryLoading(true));
        const response = yield call(getChapterAttemptHistoryApi, studentId, chapterId);
        const dto = response?.data ? { ...response.data, kind: 'chapter' } : null;
        yield put(scoringActions.setAttemptHistory(dto));
    } catch (error) {
        yield put(scoringActions.setAttemptHistoryError(error?.message || 'Failed to load attempt history'));
        yield put(toastAction.onErrorToast(error?.message || 'Failed to load attempt history'));
    }
}

function* onLoadAssessmentSummary({ payload }) {
    try {
        const studentId = payload?.studentId;
        const courseId = payload?.courseId;
        if (!studentId || !courseId) return;
        yield put(scoringActions.setAssessmentSummaryLoading(true));
        const response = yield call(getAssessmentSummaryApi, studentId, courseId);
        yield put(scoringActions.setAssessmentSummary(response?.data || []));
    } catch (error) {
        yield put(scoringActions.setAssessmentSummaryError(error?.message || 'Failed to load assessment summary'));
        yield put(toastAction.onErrorToast(error?.message || 'Failed to load assessment summary'));
    }
}

function* onLoadStrengthsWeaknesses({ payload }) {
    try {
        const studentId = payload?.studentId;
        const courseId = payload?.courseId;
        if (!studentId || !courseId) return;
        yield put(scoringActions.setStrengthsWeaknessesLoading(true));
        const response = yield call(getStrengthsWeaknessesApi, studentId, courseId);
        yield put(scoringActions.setStrengthsWeaknesses(response?.data || null));
    } catch (error) {
        yield put(scoringActions.setStrengthsWeaknessesError(error?.message || 'Failed to load strengths/weaknesses'));
        yield put(toastAction.onErrorToast(error?.message || 'Failed to load strengths/weaknesses'));
    }
}

function* scoringWatcherSaga() {
    yield takeEvery(scoringActions.loadStudentTests.type, onLoadStudentTests);
    yield takeEvery(scoringActions.loadAttemptHistory.type, onLoadAttemptHistory);
    yield takeEvery(scoringActions.loadStudentChapters.type, onLoadStudentChapters);
    yield takeEvery(scoringActions.loadChapterAttemptHistory.type, onLoadChapterAttemptHistory);
    yield takeEvery(scoringActions.loadAssessmentSummary.type, onLoadAssessmentSummary);
    yield takeEvery(scoringActions.loadStrengthsWeaknesses.type, onLoadStrengthsWeaknesses);
}

export default scoringWatcherSaga;
